import { BUNDLE_SUBCATEGORIES } from '~/constants';

/**
 * Coerces the GraphQL JSONObject `bundleSubcategories` field into a typed map,
 * filtering out any entries whose values are not string arrays.
 * Falls back to the local BUNDLE_SUBCATEGORIES constant when the API value is
 * absent or malformed.
 */
export function parseBundleSubcats(raw: unknown): Record<string, string[]> {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return BUNDLE_SUBCATEGORIES;
  const validated: Record<string, string[]> = {};
  for (const [key, val] of Object.entries(raw)) {
    if (Array.isArray(val) && val.every((v) => typeof v === 'string')) {
      validated[key] = val;
    }
  }
  return Object.keys(validated).length > 0 ? validated : BUNDLE_SUBCATEGORIES;
}
